import React from 'react';
import '../css/dashboard.css';
import { APP_NAME, APP_VERSION } from '../constants';

export default function Footer() {
  return (
    <>
      <br />
      <br />
      <br />
      <div className="footer bg-light text-center py-3 mt-auto">
        <p className="mb-0">
          &copy; {new Date().getFullYear()} {APP_NAME}. All Rights Reserved.
        </p>
        <p className="mb-0">App Version: {APP_VERSION}</p>
      </div>
    </>
  );
}
